import { cn } from '@/lib/utils'

interface VisitsSheetSectionCardProps {
  title?: React.ReactNode
  body: React.ReactNode
  className?: string
}

/** Titled section card for the Visits details sheet (matches the Calls sheet). */
export function VisitsSheetSectionCard({
  title,
  body,
  className,
}: VisitsSheetSectionCardProps) {
  return (
    <div
      className={cn(
        'bg-app border border-neutral-ui-border shadow-[var(--shadow-md)] rounded-lg p-3',
        className
      )}>
      {title != null && (
        <p className="text-muted-foreground mb-2 text-xs font-medium tracking-wide">
          {title}
        </p>
      )}
      {body}
    </div>
  )
}
